import { UserProfile } from '../models';
import { fileToBase64 } from '../utils/fileToBase64';

export const ACCESS_TOKEN = 'accessToken';
export const REFRESH_TOKEN = 'refreshToken';
export const USER = 'user';
export const CURRENT_USER_GUID = 'current_user_guid';

export function saveAssesTokenStorage(accessToken: string) {
  localStorage.setItem(ACCESS_TOKEN, accessToken);
}

export function getAssesTokenStorage() {
  return localStorage.getItem(ACCESS_TOKEN) ?? null;
}

export function saveRefreshTokenStorage(refreshToken: string) {
  localStorage.setItem(REFRESH_TOKEN, refreshToken);
}

export function getRefreshTokenStorage() {
  return localStorage.getItem(REFRESH_TOKEN) ?? null;
}

export async function saveUserStorage(user: UserProfile) {
  if (
    user?.user_meta?.profile_image &&
    !user?.user_meta?.profile_image.startsWith('data:image/jpeg')
  ) {
    user.user_meta.profile_image = await fileToBase64(
      user?.user_meta?.profile_image
    );
  }
  if (
    user?.user_meta?.cover_image &&
    !user?.user_meta?.cover_image.startsWith('data:image/jpeg')
  ) {
    user.user_meta.cover_image = await fileToBase64(user?.user_meta?.cover_image);
  }

  if (user?.guid) {
    setUserSomeDataStorage(USER, user, user?.guid);
    setUserSomeDataStorage(CURRENT_USER_GUID, user?.guid);
  }
}

export function clearStorage() {
  localStorage.clear();
}

export function removeUserStorage(userId: string) {
  removeUserSomeDataStorage(USER, userId);
  localStorage.removeItem(ACCESS_TOKEN);
  localStorage.removeItem(REFRESH_TOKEN);
  localStorage.removeItem(CURRENT_USER_GUID);
}

export function getUserStorage(userId?: string) {
  const userString = getUserSomeDataStorage(USER, userId);
  if (!userString || userString === 'undefined') {
    return null;
  } else {
    return JSON.parse(userString) as UserProfile;
  }
}

export function getStorage(key: string) {
  const storedValue = localStorage.getItem(key);

  if (storedValue === null) {
    return null;
  }

  if (isJsonOrString(storedValue)) {
    return JSON.parse(storedValue);
  }

  return storedValue;
}

export function setStorage(key: string, value: string) {
  localStorage.setItem(key, value);
}

export function removeStorage(key: string) {
  localStorage.removeItem(key);
}

export async function setUserSomeDataStorage(
  key: string,
  value: any,
  userId?: string
) {
  if (userId) {
    const currentUserData = JSON.parse(localStorage.getItem(userId) || '{}');
    const newData = { ...currentUserData, [key]: value };

    localStorage.setItem(userId, JSON.stringify(newData));
  } else {
    setStorage(key, JSON.stringify(value));
  }
}

export function getUserSomeDataStorage(key: string, userId?: string) {
  if (userId) {
    const currentUserData = JSON.parse(localStorage.getItem(userId) || '{}');
    return currentUserData[key];
  } else {
    return getStorage(key);
  }
}

export function removeUserSomeDataStorage(key: string, userId?: string) {
  if (userId) {
    const currentUserData = JSON.parse(localStorage.getItem(userId) || '{}');

    if (Object.keys(currentUserData).length) {
      if (key in currentUserData) {
        delete currentUserData[key];
      }

      localStorage.setItem(userId, JSON.stringify(currentUserData));
    }
  }
  removeStorage(key);
}

function isJsonOrString(value: string): boolean {
  try {
    JSON.parse(value);
    return true;
  } catch {
    return false;
  }
}
